import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { SignalBars } from "../components/common";
import { LogOut, ChevronRight, Globe } from "lucide-react";

export default function PlayerHome() {
  const nav = useNavigate();
  const { logout } = useAuth();
  const [camps, setCamps] = useState([]);

  useEffect(() => {
    api.get("/me/campaigns").then((r) => {
      setCamps(r.data);
      if (r.data.length === 1) nav(`/play/${r.data[0].campaign_id}`, { replace: true });
    });
  }, [nav]);

  return (
    <div className="min-h-full max-w-md mx-auto border-x border-[color:var(--r-primary)]/15 flex flex-col">
      <header className="h-14 px-4 flex items-center justify-between border-b border-[color:var(--r-primary)]/15 panel">
        <div className="flex items-center gap-2">
          <SignalBars />
          <span className="font-title font-black tracking-tight">RÉPLA <span style={{ color: "var(--r-primary)" }}>// COM</span></span>
        </div>
        <button data-testid="logout-button" onClick={() => { logout(); nav("/login"); }} className="text-[color:var(--r-text-muted)]"><LogOut size={16} /></button>
      </header>
      <main className="p-5">
        <div className="sys-label mb-1">ACCÈS AUTORISÉS</div>
        <h2 className="font-title font-bold text-xl tracking-tight mb-5">MES UNIVERS</h2>
        <div className="space-y-3">
          {camps.map((c) => (
            <button
              key={c.campaign_id}
              data-testid={`player-campaign-${c.campaign_id}`}
              onClick={() => nav(`/play/${c.campaign_id}`)}
              className="w-full frame p-4 text-left flex items-center gap-3"
            >
              <Globe size={18} style={{ color: "var(--r-primary)" }} />
              <div className="flex-1">
                <div className="font-title font-bold tracking-tight">{c.universe_name}</div>
                <div className="sys-label mt-1" style={{ textTransform: "none", letterSpacing: "normal" }}>{c.campaign_name} · {c.character.name}</div>
              </div>
              <ChevronRight size={16} className="text-[color:var(--r-text-muted)]" />
            </button>
          ))}
          {camps.length === 0 && <div className="sys-label">AUCUNE CAMPAGNE ASSIGNÉE</div>}
        </div>
      </main>
    </div>
  );
}
